import { collectLoad, collectReserve, getCollectionHistory, getCollections } from './collections.action';
export { collectionReducer } from './collections.reducer';
export { watchCollection } from './collections.saga';

export const collectionActions = {
  /** Collections */
  getCollections,
  getCollectionHistory,
  collectReserve,
  collectLoad,
  /** End */
}
